import Api from '../../api'
import { put, takeLatest, call } from 'redux-saga/effects'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { delay } from 'redux-saga'
import getProjectName from 'portal-modules/common/utils/get-project-name'

import {
  hideLoader,
  showDeleteSuccess,
  showInviteSuccessModal,
} from 'portal-modules/common/redux/modules/toggleSuccessModals'

// action types
const RECEIVE_USERS = 'rp/users/RECEIVE_USERS'
const REQUEST_USERS = 'rp/users/REQUEST_USERS'
const SET_USER_PERMISSIONS = 'rp/users/SET_USER_PERMISSIONS'
const DELETE_USER = 'rp/users/DELETE_USER'
const USER_DELETED = 'rp/users/USER_DELETED'
const UPLOAD_USER_IMAGE = 'rp/profile/UPLOAD_USER_IMAGE'
const UPDATE_USER_IMAGE = 'rp/users/UPDATE_USER_IMAGE'
const SEND_RESET_PASSWORD = 'rp/users/SEND_RESET_PASSWORD'
const RESET_PASSWORD_SENT = 'rp/users/RESET_PASSWORD_SENT'

// reducer
export default (state = { users: [], permissions: [] }, { payload, type }) => {
  switch (type) {
    case RECEIVE_USERS:
      return { ...state, users: payload }
    case SET_USER_PERMISSIONS:
      return { ...state, permissions: payload }
    case UPDATE_USER_IMAGE:
      return {
        ...state,
        users: state.users.map(currentUser =>
          currentUser.id === payload.id
            ? {
                ...currentUser,
                profile_image_url: payload.image_path,
              }
            : currentUser,
        ),
      }
    case USER_DELETED:
      return {
        ...state,
        users: state.users.filter(({ id }) => id !== payload.id),
      }
    case RESET_PASSWORD_SENT:
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}

// action creators
export const requestUsers = () => ({ type: REQUEST_USERS })

export const deleteUser = (payload, callback) => ({
  type: DELETE_USER,
  payload,
  callback,
})

export const receiveUsers = payload => ({
  type: RECEIVE_USERS,
  payload,
})

export const setUserPermissions = payload => ({
  type: SET_USER_PERMISSIONS,
  payload,
})

export const uploadUsersImage = (payload, callback) => ({
  type: UPLOAD_USER_IMAGE,
  callback,
  payload,
})

export const userImageUpload = payload => ({
  type: UPDATE_USER_IMAGE,
  payload,
})

export const sendResetPassword = (payload, callback) => ({
  type: SEND_RESET_PASSWORD,
  payload,
  callback,
})
// sagas
function* fetchUsers() {
  const { tenant_users = [], group_users = [], settings } = yield call(
    Api.getUsers,
  )
  const users = 'rh' === getProjectName() ? group_users : tenant_users

  yield put({ type: RECEIVE_USERS, payload: users })
  yield put({ type: SET_USER_PERMISSIONS, payload: settings })
}

function* watchGetUsers() {
  yield takeLatest(
    REQUEST_USERS,
    createRequestSaga(fetchUsers, {
      key: 'users',
      message: __('Checking for Users'),
    }),
  )
}

function* postDeleteUser({ payload, callback }) {
  const params = {}

  if ('rh' === getProjectName()) {
    params['group_user_id'] = payload.id
  } else {
    params['tenant_user_id'] = payload.id
  }

  const msg = yield call(Api.deleteUser, params)

  if (msg) {
    yield put(hideLoader())
    yield put(showDeleteSuccess(payload.deleteUserInfo))
    yield put({ type: USER_DELETED, payload })
  }
  typeof callback === 'function' && callback()
}

function* postUserImage({ payload }) {
  const { success, image_path } = yield call(Api.uploadProfileImage, {
    profileImage: payload,
  })
  let userImagePayload = {
    id: payload.tenant_user_id,
    image_path: image_path,
  }
  if (getProjectName() == 'rh') {
    userImagePayload['id'] = payload.group_user_id
  }

  if (success) {
    yield put(hideLoader())
    yield put(userImageUpload(userImagePayload))
    yield put(
      showInviteSuccessModal({
        fromProfile: true,
      }),
    )
  }
}

function* postResetPasswordSent({ payload, callback }) {
  const success = yield call(Api.sendResetPassword, payload)

  if (success) {
    yield put({ type: RESET_PASSWORD_SENT })
    yield put(hideLoader())

    yield put(
      showInviteSuccessModal({
        fromResetPassword: true,
      }),
    )
  } else {
    yield 500
    yield put(hideLoader())
  }
  typeof callback === 'function' && callback()
}

// watchers
function* watchDeleteUser() {
  yield takeLatest(
    DELETE_USER,
    createRequestSaga(postDeleteUser, {
      key: 'users',
      message: __('Deleting user'),
      write: true,
    }),
  )
}

function* watchUploadProfileImage() {
  yield takeLatest(
    UPLOAD_USER_IMAGE,
    createRequestSaga(postUserImage, {
      key: 'users',
      message: __('Uploading user profile image.'),
      successMessage: __('User image updated!'),
      write: true,
    }),
  )
}

function* watchResetPasswordLink() {
  yield takeLatest(
    SEND_RESET_PASSWORD,
    createRequestSaga(postResetPasswordSent, {
      key: 'users',
      message: __('Reset password link sent to user.'),
      write: true,
    }),
  )
}

export const sagas = [
  watchGetUsers,
  watchDeleteUser,
  watchUploadProfileImage,
  watchResetPasswordLink,
]
